export default "__VITE_ASSET__CJVIfyAo__"